// React
import { memo, useCallback, useMemo } from 'react'

// Quill Editor
import ReactQuill, { Quill } from 'react-quill'
import 'react-quill/dist/quill.snow.css'

// Interfaces
import { IBaseQuillEditorProps } from './interfaces'

// i18n
import { useTranslation } from 'react-i18next'

// Init Quill Font
const Font = Quill.import('formats/font')
Font.whitelist = ['Inter']
Quill.register(Font, true)

const BaseQuillEditor = memo(({ commonValue, onChangeCommon, placeholder }: IBaseQuillEditorProps) => {
  // Hook
  const { t } = useTranslation()
  const modules = useMemo(() => {
    return {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ list: 'ordered' }, { list: 'bullet' }],
      ],
    }
  }, [])
  const formats = useMemo(() => {
    return ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet']
  }, [])

  /**
   * @description Watch any change in quill
   *
   * @param {string} value
   *
   * @return {void} void
   */
  const onChangeQuill = useCallback((quillValue: string): void => {
    onChangeCommon(quillValue)

    // eslint-disable-next-line
  }, [])

  return (
    <>
      <ReactQuill
        theme="snow"
        value={commonValue}
        onChange={onChangeQuill}
        placeholder={t(placeholder)}
        modules={modules}
        formats={formats}
      />
    </>
  )
})

export { BaseQuillEditor }
